<template>
  <mds-layout-grid>
    <mds-row>
      <mds-col :cols="9">
        <div v-if="metadataItems.length > 0" :class="$style['metadata-list']">
          <span
            v-for="(metadata, index) in metadataItems"
            :key="`metadata-${index}`"
            :class="$style['metadata-list__item']"
          >
            <span>{{ metadata }}</span>
          </span>
        </div>
        <DataTable :columns="headers" :rows="rows">
          <template #timeSchedule="{row}">
            {{ getHistoricalMaxFeeStartDate(row.start) }} - {{ getFormattedDate(row.end) }}
          </template>
          <template #maxFee="{ row }">
            {{ timeScheduleMaxFee(row) }}
          </template>
        </DataTable>
      </mds-col>
    </mds-row>
  </mds-layout-grid>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import { MdsLayoutGrid, MdsRow, MdsCol } from '@mds/layout-grid';
import HistoricMaxFeeMetadataMixin from '../../mixins/metadata/historic-max-fee-mixin';
import DataTable from '../../common/DataTable';
import { getHistoricMaxOrManagerFeeStartDate } from '../../utils';

export default {
  name: 'historic-max-fee-details-view',
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    DataTable,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin, HistoricMaxFeeMetadataMixin],
  props: {
    schedule: Object,
  },
  data() {
    return {
      rows: this.schedule.feeScheduleDetails,
    };
  },
  computed: {
    feeScheduleTypeText() {
      return this.translate('historicMaxFee');
    },
    headers() {
      return [
        {
          text: this.translate('timeSchedule'),
          fieldName: 'timeSchedule',
          align: 'left',
          style: {
            width: '120px',
          },
        },
        {
          text: this.translate('annualMaxFeePercent'),
          fieldName: 'maxFee',
          align: 'right',
          style: {
            width: '80px',
          },
        },
      ];
    },
    metadataItems() {
      const metadataItems = [this.feeScheduleTypeText, this.maxDiscountDescription];
      if (this.schedule.separateAccountManagerFee) {
        metadataItems.push(this.SMAFeeExcludedDescription);
      }
      return metadataItems;
    },
  },
  methods: {
    getFormattedDate(dateStr) {
      const date = new Date(dateStr);
      const monthStr = date.toLocaleString('default', { month: 'short' });
      const dayStr = String(date.getDate()).padStart(2, '0');
      const yearStr = String(date.getFullYear()).padStart(4, '0');
      return `${monthStr} ${dayStr}, ${yearStr}`;
    },
    getHistoricalMaxFeeStartDate(dateStr) {
      return getHistoricMaxOrManagerFeeStartDate(
        dateStr,
        this.getFormattedDate,
        this.translate,
        this.settings.isActualWorkflow
      );
    },
    timeScheduleMaxFee(timeSchedule) {
      const { maxFee } = timeSchedule;
      return this.formatter.number(maxFee, 'shortDecimal');
    },
  },
};
</script>

<style lang="scss" module>
@import '../../styles/fee-schedule-item.scss';
</style>
